import ApiCore from './api-core'
import { IDENTIFY } from '@/constants/api-types'

export default class FinancialCommercialBanking extends ApiCore {
  constructor(store) {
    super(store, `${IDENTIFY}/commercialBanking`)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
